import { call, put } from "redux-saga/effects";

import { api, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";
import { requestErrorHandler } from "utils";
import { InvoicePickingActions } from "store/ducks/pickings";

export function* invoicePickingRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      api.post,
      `/pickings-invoice`,
      postData
    );

    const { data } = responseBody;
    yield put(InvoicePickingActions.success(data));
    notify("success", "Nota fiscal relacionada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(InvoicePickingActions.failure(errorMessage));
  }
}
